.app-banner {
  width: 100%;
  background: rgb(225 242 255 / 70%);

  @include desktop {
    display: none;
  }

  // `min-height` sits on the row itself rather than on a `--reserve` modifier: the server renders
  // the title and rating but not the store button (the store is only known on the client), and
  // Stencil's hydration only ADDS classes from the client vnode — it never removes the ones the
  // SSR markup already carries. A modifier class therefore survived on the filled-in banner. Same
  // height either way, so one rule covers both.
  .app-banner__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: 56px;
    padding: 10px 16px;
  }

  .app-banner__column {
    &:last-child {
      width: 42px;
    }
  }

  .app-banner__title {
    font-size: 14px;
    line-height: 20px;
    font-weight: map-get($font-weights, bold);
    color: var(--text-color-primary);
  }

  .app-banner__description {
    font-size: 12px;
    line-height: 16px;
    color: var(--text-color-primary);
  }

  .rating-accent {
    position: relative;
    padding-left: 68px;
    font-weight: map-get($font-weights, bold);

    &::before {
      display: block;
      position: absolute;
      content: '';
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='12' fill='none' viewBox='0 0 64 12'%3E%3Cpath fill='%230777cf' d='M6.233 9.122a.5.5 0 0 0-.466 0l-2.397 1.26a.5.5 0 0 1-.725-.526l.457-2.67a.5.5 0 0 0-.143-.442l-1.94-1.89A.5.5 0 0 1 1.296 4l2.68-.39a.5.5 0 0 0 .377-.273L5.552.908a.5.5 0 0 1 .896 0l1.199 2.43a.5.5 0 0 0 .376.273l2.68.39a.5.5 0 0 1 .278.852l-1.94 1.89a.5.5 0 0 0-.143.443l.457 2.67a.5.5 0 0 1-.725.527zm13 0a.5.5 0 0 0-.466 0l-2.397 1.26a.5.5 0 0 1-.726-.526l.458-2.67a.5.5 0 0 0-.143-.442l-1.94-1.89A.5.5 0 0 1 14.296 4l2.68-.39a.5.5 0 0 0 .377-.273L18.552.908a.5.5 0 0 1 .896 0l1.199 2.43a.5.5 0 0 0 .377.273l2.68.39a.5.5 0 0 1 .277.852l-1.94 1.89a.5.5 0 0 0-.143.443l.457 2.67a.5.5 0 0 1-.725.527zm13 0a.5.5 0 0 0-.466 0l-2.397 1.26a.5.5 0 0 1-.726-.526l.458-2.67a.5.5 0 0 0-.143-.442l-1.94-1.89A.5.5 0 0 1 27.296 4l2.68-.39a.5.5 0 0 0 .377-.273L31.552.908a.5.5 0 0 1 .896 0l1.199 2.43a.5.5 0 0 0 .377.273l2.68.39a.5.5 0 0 1 .277.852l-1.94 1.89a.5.5 0 0 0-.143.443l.457 2.67a.5.5 0 0 1-.725.527zm13 0a.5.5 0 0 0-.466 0l-2.397 1.26a.5.5 0 0 1-.725-.526l.457-2.67a.5.5 0 0 0-.143-.442l-1.94-1.89A.5.5 0 0 1 40.296 4l2.68-.39a.5.5 0 0 0 .377-.273L44.552.908a.5.5 0 0 1 .896 0l1.199 2.43a.5.5 0 0 0 .377.273l2.68.39a.5.5 0 0 1 .277.852l-1.94 1.89a.5.5 0 0 0-.143.443l.457 2.67a.5.5 0 0 1-.725.527zm13 0a.5.5 0 0 0-.466 0l-2.397 1.26a.5.5 0 0 1-.725-.526l.457-2.67a.5.5 0 0 0-.143-.442l-1.94-1.89A.5.5 0 0 1 53.296 4l2.68-.39a.5.5 0 0 0 .377-.273L57.552.908a.5.5 0 0 1 .896 0l1.199 2.43a.5.5 0 0 0 .377.273l2.68.39a.5.5 0 0 1 .277.852l-1.94 1.89a.5.5 0 0 0-.143.443l.457 2.67a.5.5 0 0 1-.725.527z'/%3E%3Cmask id='a' width='12' height='11' x='52' y='0' maskUnits='userSpaceOnUse' style='mask-type:alpha'%3E%3Cpath fill='%230777cf' d='M58.233 9.122a.5.5 0 0 0-.466 0l-2.397 1.26a.5.5 0 0 1-.725-.526l.457-2.67a.5.5 0 0 0-.143-.442l-1.94-1.89A.5.5 0 0 1 53.296 4l2.68-.39a.5.5 0 0 0 .377-.273L57.552.908a.5.5 0 0 1 .896 0l1.199 2.43a.5.5 0 0 0 .377.273l2.68.39a.5.5 0 0 1 .277.852l-1.94 1.89a.5.5 0 0 0-.143.443l.457 2.67a.5.5 0 0 1-.725.527z'/%3E%3C/mask%3E%3Cg mask='url(%23a)'%3E%3Cpath fill='%238ec1e9' d='M58 0h6v11h-6z'/%3E%3C/g%3E%3C/svg%3E");
      top: 2px;
      left: 0;
      background-size: contain;
      background-repeat: no-repeat;
      width: 64px;
      height: 12px;
    }
  }

  .download-btn-logo {
    display: block;
    width: 24px;
    height: 24px;
    margin: 6px 0 6px auto;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%230777cf' fill-rule='evenodd' d='M14.293 11.293 13 12.586V3a1 1 0 1 0-2 0v9.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414M3 15.039a1 1 0 0 0-1 1V20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3.961a1 1 0 1 0-2 0V20H4v-3.961a1 1 0 0 0-1-1' clip-rule='evenodd'/%3E%3C/svg%3E");
    background-size: cover;
  }
}
